import styles from './SaveButton.module.css';

function SaveButton({ text, onClick, disabled }) {
  return (
    <button className={styles.saveButton} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
}
export default SaveButton;